"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-four/sections/counterSection.tsx */

import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type CounterSection36sItem = {
    key: Key | null | undefined;
    /** Detected variants: "+" | "%" */
    h30Text: ReactNode;
    /** Detected variants: "Happy Little Patients" | "Years of Experience" | "Parent Satisfaction" | "Certified Specialists" */
    p0Text: ReactNode;
    /** Detected variants: "col-xl-3 col-sm-6 d-flex" */
    className?: string;
    /** Detected variants: "counter-item-four flex-fill" */
    div0ClassName?: string;
    /** Detected variants: "sub-title" */
    p0ClassName?: string;
    /** Detected variants: "isVisible ? (\n                    <CountUp end={5000} duration={3} separator=\",\" />\n                  ) : '0'" | "isVisible ? (\n                    <CountUp end={10} duration={3} />\n                  ) : '0'" | "isVisible ? (\n                    <CountUp end={98} duration={3} />\n                  ) : '0'" | "isVisible ? (\n                    <CountUp end={300} duration={3} separator=\",\" />\n                  ) : '0'" */
    div0h30Expr0: ReactNode;
};
export type HomeFourCounterSectionGeneratedProps = {
    divDiv0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: CounterSection36sItem) => Partial<ComponentProps<"h3">>);
    /** Default: "Where Heart Health Meets" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Advanced Care" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    counterSection36s: CounterSection36sItem[];
    counterSection36sItemWrapper?: (item: CounterSection36sItem, content: ReactNode) => ReactNode;
    counterSection36sRenderer?: (defaultNode: ReactNode) => ReactNode;
    counterSection36sH3Visible?: boolean;
    counterSection36sH3Renderer?: (item: CounterSection36sItem, defaultNode: ReactNode) => ReactNode;
    counterSection36sH3Props?: Partial<ComponentProps<"h3">> | ((item: CounterSection36sItem) => Partial<ComponentProps<"h3">>);
};

const HomeFourCounterSectionGenerated: FC<HomeFourCounterSectionGeneratedProps> = ({
    sectionDiv0Div0H20H2Text = "Where Heart Health Meets",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "Advanced Care",
    divDiv0H30H3Props,
    sectionDiv0Div1ClassName,
    counterSection36s,
    counterSection36sItemWrapper,
    counterSection36sRenderer,
    counterSection36sH3Visible,
    counterSection36sH3Renderer,
    counterSection36sH3Props,
}) => {
    return (
        <section className="counter-section-four section">
            <div className="container">
                <div className="section-header section-header-four text-center">
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            <span>{sectionDiv0Div0H20Span0SpanText}</span>
                        </h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row g-4"}>
                    {renderCollectionNode(
                        counterSection36s,
                        (item: CounterSection36sItem) => (
                            <div className={item.className ?? "col-xl-3 col-sm-6 d-flex"} key={item.key}>
                                <div className={item.div0ClassName ?? "counter-item-four flex-fill"}>
                                    {renderItemNode(counterSection36sH3Visible, counterSection36sH3Renderer, item, (
                                        <h3 {...(typeof counterSection36sH3Props === "function" ? counterSection36sH3Props(item) : (counterSection36sH3Props ?? {}))} {...(typeof divDiv0H30H3Props === "function" ? divDiv0H30H3Props(item) : (divDiv0H30H3Props ?? {}))}>{item.h30Text}</h3>
                                    ))}
                                    <p className={item.p0ClassName ?? "sub-title"}>{item.p0Text}</p>
                                </div>
                            </div>
                        ),
                        counterSection36sItemWrapper,
                        counterSection36sRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeFourCounterSectionGenerated;
